import type { RouteObject } from 'react-router';
import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

export const consultantAnnouncementRoutes: RouteObject[] = [
  {
    path: 'consultant-announcements',
    lazy: page('ConsultantAnnouncementListPage'),
    handle: { title: '컨설턴트 공고', feature: 'CONSULTANT_ANNOUNCEMENT' } satisfies RouteHandle,
  },
  {
    path: 'consultant-announcements/:id',
    lazy: page('ConsultantAnnouncementDetailPage'),
    handle: {
      title: '컨설턴트 공고 상세',
      yearIndependent: true,
      feature: 'CONSULTANT_ANNOUNCEMENT',
    } satisfies RouteHandle,
  },
];
